import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useReadCharterRequest = (requestId) => {
  const { token } = useContext(AuthContext);

  const fetchCharterRequest = async () => {
    if (!token) throw new Error("Token is missing");
    if (!requestId) throw new Error("Request ID is required");
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/charterer/readCharterRequest/${requestId}`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch charter request");
    }
    return data;
  };

  const {
    data: charterRequestData,
    error: charterRequestError,
    isLoading: charterRequestLoading,
    refetch: refetchCharterRequest,
  } = useQuery(
    ["readCharterRequest", requestId],
    fetchCharterRequest,
    {
      enabled: !!token && !!requestId,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  return {
    charterRequest: charterRequestData?.data || null,
    charterRequestError,
    charterRequestLoading,
    refetchCharterRequest,
  };
};

export default useReadCharterRequest; 